import { Friendship } from '../models';
import { FriendshipRepository } from '../repositories';
import { logger } from '@/src/core/utils';

export class DeclineFriendRequestUseCase {
  constructor(private friendshipRepository: FriendshipRepository) {}

  async execute(friendshipId: string): Promise<Friendship> {
    logger.debug('DeclineFriendRequest', 'Declining friend request', { friendshipId });

    const friendship = await this.friendshipRepository.declineRequest(friendshipId);

    logger.debug('DeclineFriendRequest', 'Friend request declined successfully');

    return friendship;
  }
}
